import { ExpanderButton } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/MeasureProgress/components/ExpanderButton";
import { InfoContent } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/MeasureProgress/components/InfoContent";
import { ProgressionBody } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/MeasureProgress/components/ProgressionBody";
import { SectionStateContent } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/SectionStateContent";
import { AltTransStretchCoverage } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { useAlternativeTransportMeasureProgress } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/useAlternativeTransportMeasureProgress";
import { Dispatch, SetStateAction, useMemo } from "react";

import { InfoHeader } from "shared/components/InfoHeader";
import { tokens, VStack } from "shared/components/Spor";
import { Nullish } from "shared/utils/objectUtils";
import { useTheme } from "styled-components";

export type StretchItem = {
  name: string;
};

interface MeasureProgressProps {
  showAllStretches: boolean;
  setShowAllStretches: Dispatch<SetStateAction<boolean>>;
  stretch: AltTransStretchCoverage | null;
  setStretch: (stretch: AltTransStretchCoverage | null) => void;
  incidentId: Nullish<string>;
}

export const MeasureProgress = ({
  showAllStretches,
  setShowAllStretches,
  stretch,
  setStretch,
  incidentId,
}: MeasureProgressProps) => {
  const theme = useTheme();

  const { data, status, refetch, isRefetching } =
    useAlternativeTransportMeasureProgress(incidentId);

  const activeStretches = useMemo(() => {
    if (!data) return [];
    if (data.measureStretchCoverage.length) return data.measureStretchCoverage;
    if (data.incidentStretchCoverage) return [data.incidentStretchCoverage];
    return [];
  }, [data]);

  const isLoading = status === "pending" || isRefetching;
  const isError = status === "error";
  const isEmpty = status === "success" && activeStretches.length === 0;
  const handleRefetch = () => {
    void refetch();
  };

  return (
    <VStack
      backgroundColor={theme.colorBackgroundSecondary}
      borderRadius={tokens.default.size.spacing[1]}
      flex="1"
      overflow="hidden"
      zIndex={tokens.default.depth["z-index"].overlay + 1}
      minHeight="380px"
      height="100%"
      p={tokens.default.size.spacing[2]}
      gap={0}
    >
      <InfoHeader
        title="Progresjon for tiltak"
        alignment="right"
        iconColor={theme.colorIconSecondary}
        tooltipWidth="360px"
      >
        <InfoContent />
      </InfoHeader>
      <SectionStateContent
        isLoading={isLoading}
        isError={isError}
        isEmpty={isEmpty}
        onRetry={handleRefetch}
      >
        <>
          <ProgressionBody
            showAllStretches={showAllStretches}
            stretch={stretch}
            setStretch={setStretch}
            allStretchCoverages={activeStretches}
            totalCoverage={data?.totalCoverage}
            totalPassengersRequiringTransport={
              data?.totalPassengersRequiringTransport
            }
          />
          <ExpanderButton
            showAllStretches={showAllStretches}
            setShowAllStretches={setShowAllStretches}
            stretchCount={activeStretches.length}
          />
        </>
      </SectionStateContent>
    </VStack>
  );
};
